module.exports = __webpack_public_path__ + "img/ugncp.7fcbb9ec.png";